import React from "react";
import {
  AISVesselDto,
  PaginatedListOfAISVesselDto,
  useThirdPartyApi,
} from "~/api/GeneratedApi";
import { useCustomQuery } from "~/utils/hooks/useCustomQuery";

export const aisListQueryKey = "ais-vessels-new" as const;

export function useAISVessels() {
  const { getFilteredAISItems } = useThirdPartyApi();

  const { data: aisData } = useCustomQuery(
    aisListQueryKey,
    () => getFilteredAISItems(),
    {
      // staleTime: Number.POSITIVE_INFINITY,
      select: React.useCallback(
        (d: PaginatedListOfAISVesselDto) => d.results,
        [],
      ),
      // refetchInterval: 30000,
    },
  );

  const aisVessels = React.useMemo(
    () => aisData ?? ([] as AISVesselDto[]),
    [aisData],
  );

  const getAISVesselById = React.useCallback(
    (mmsi: number) => {
      const vessel = aisVessels.find((x) => x.mmsi === mmsi);

      return vessel ?? null;
    },
    [aisVessels],
  );

  const aisVesselsWithRouter = React.useMemo(() => {
    const filteredVessels = (aisData ?? []).filter((v) => v.router);

    return filteredVessels;
  }, [aisData]);

  const someVesselHasAlarm = React.useMemo(() => {
    return aisVesselsWithRouter.some((v) => {
      if (!v.router?.vesselTelemetry?.activeAlarms) return false;
      return v.router?.vesselTelemetry?.activeAlarms?.length > 0;
    });
  }, [aisVesselsWithRouter]);

  return {
    aisVessels,
    getFilteredAISItems,
    getAISVesselById,
    aisVesselsWithRouter,
    someVesselHasAlarm,
  };
}
